import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsAlertsTappedParams = {
  alert_count: number;
  trail_id: number;
};

/**
 * User taps alerts on the trail details page. Fires once per tap.
 * @param params - Attributes to log with the amplitude event
 * @param params.alert_count - The number of alerts present on the trail at the time the alert was tapped.
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsAlertsTapped = ({ alert_count, trail_id }: logTrailDetailsAlertsTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details alerts tapped', { 'alert count': alert_count, 'trail id': trail_id }, callback);
};

export default logTrailDetailsAlertsTapped;
